/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Formik, Form } from 'formik';
import {
  CardBody,
  Button,
  FormGroup,
  Label,
  Row,
  Col,
  Input,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { ToastShow } from '../../redux/toast/toast.action';
import { connect } from 'react-redux';
import {
  addTermsCondition,
  getTermsCondition,
} from '../../services/terms_condition.service';

const initial_state = {
  content: '',
};

const TermsCondition = (props) => {
  const { setToast } = props;
  let history = useHistory();
  const [loader, setLoader] = useState(false);
  const [initialValues, setInitialValues] = useState(initial_state);

  useEffect(() => {
    getTermsAndCondition();
  }, []);

  const getTermsAndCondition = async () => {
    const res = await getTermsCondition();
    if (res.data.response_type === 'success') {
      const data = res.data.data;
      if (data !== []) {
        setInitialValues({
          ...initialValues,
          content: data.content ? data.content : '',
        });
      }
    }
  };

  const submitEvent = async (value) => {
    setLoader(true);
    const formData = new FormData();
    formData.append('content', value.content);

    const res = await addTermsCondition(formData);
    if (res.data.response_type === 'success') {
      setToast('Terms & Condition Updated!!!');
      history.push('/');
    }
    setLoader(false);
    setToast(res.data.message);
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize={true}
      onSubmit={(values) => {
        submitEvent(values);
      }}
    >
      {({ values, setFieldValue }) => {
        return (
          <div className='content-wrapper'>
            <Form>
              <CardBody>
                <Row>
                  <Col sm={12} md={12}>
                    <FormGroup>
                      <Label htmlFor='Content'>Terms & Condition</Label>
                      <Input
                        type='textarea'
                        placeholder='Terms & Condition Content'
                        style={{ border: '1px solid black' }}
                        name='content'
                        value={values.content}
                        rows={5}
                        onChange={(e) =>
                          setFieldValue('content', e.target.value)
                        }
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </CardBody>
              <div className='card-footer text-center'>
                <Button
                  type='submit'
                  color='primary'
                  disabled={loader ? true : false}
                >
                  {loader ? (
                    <i className='fas fa-3x fa-sync-alt fa-spin mr-2'></i>
                  ) : (
                    ''
                  )}
                  Update
                </Button>
                <span className='ml-3'>
                  <Button
                    type='button'
                    color='secondary'
                    onClick={() => {
                      history.push('/');
                    }}
                  >
                    Back
                  </Button>
                </span>
              </div>
            </Form>
          </div>
        );
      }}
    </Formik>
  );
};

const mapDispatchToProps = (dispatch) => ({
  setToast: (message) => dispatch(ToastShow({ message })),
});

export default connect(null, mapDispatchToProps)(TermsCondition);
